import { Link } from 'react-router-dom';

interface ArticleCardProps {
  id: string;
  code: string;
  title: string;
  coverImage: string;
  studio: string;
  releaseDate: string;
  rating: number;
  views: number;
  tags: string[];
  category: string;
}

export default function ArticleCard({
  id,
  code,
  title,
  coverImage,
  studio,
  releaseDate,
  rating,
  views,
  tags,
}: ArticleCardProps) {
  return (
    <Link
      to={`/article/${id}`}
      className="group block bg-background-50 rounded-lg border border-background-200/70 overflow-hidden hover:border-primary-200 transition-all duration-300 cursor-pointer"
    >
      <div className="aspect-[3/4] overflow-hidden relative">
        <img
          src={coverImage}
          alt={title}
          className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
        />
        <div className="absolute top-2 left-2">
          <span className="px-2 py-0.5 bg-accent-500 text-background-50 text-xs font-medium rounded-md">
            {rating}
          </span>
        </div>
      </div>
      <div className="p-3 md:p-4">
        <p className="text-xs text-primary-600 font-medium mb-1">{code}</p>
        <h3 className="text-sm font-medium text-foreground-900 line-clamp-2 leading-snug mb-2 group-hover:text-primary-600 transition-colors">
          {title}
        </h3>
        <div className="flex items-center gap-2 text-xs text-foreground-500 mb-2">
          <span>{studio}</span>
          <span>·</span>
          <span>{releaseDate}</span>
        </div>
        <div className="flex items-center gap-1 flex-wrap">
          {tags.slice(0, 2).map((tag) => (
            <span
              key={tag}
              className="px-2 py-0.5 bg-secondary-100 text-secondary-700 text-xs rounded-full"
            >
              {tag}
            </span>
          ))}
          <span className="text-xs text-foreground-400 ml-auto flex items-center gap-1">
            <i className="ri-eye-line"></i>
            {views > 10000 ? `${(views / 10000).toFixed(1)}万` : views}
          </span>
        </div>
      </div>
    </Link>
  );
}